import { Routes } from '@angular/router';
import { SearchParcelComponent } from './pages/search-parcel/search-parcel.component';
import { TerminalComponent } from './pages/terminal/terminal.component';
import { SearchComponent } from './pages/search/search.component';
import { groupGuard } from './guards/group.guard';
import { UsersManagementComponent } from './pages/user-management/user-management.component';
import { AccessDeniedComponentComponent } from './pages/access-denied-component/access-denied-component.component';
import { AppComponent } from './app.component';
import { AssignedToMeComponent } from './pages/assigned-to-me/assigned-to-me.component';
import { ReprocessingComponent } from './pages/reprocessing/reprocessing.component';
import { UnassignedComponent } from './pages/unassigned/unassigned.component';
import { AllassignedComponent } from './pages/allassigned/allassigned.component';
import { MsalGuard } from '@azure/msal-angular';
import { LoginComponent } from './pages/login/login.component';
import { CustomComponent } from './pages/custom/custom.component';
import { customRedirectGuard } from './guards/custom-redirect.guard';
import { RetrievalRequestsComponent } from './pages/retrieval-requests/retrieval-requests.component';
import { retrievalRequestsUserGuard } from './guards/retrieval-requests-user.guard';
type PathMatch = "full" | "prefix" | undefined;

export const routes: Routes = [
    {
        path: '',
        component: CustomComponent,
        canActivate: [customRedirectGuard],
    },
    {
        path: 'Auth',
        component: LoginComponent,
    },
    {
        path: 'AssignedToMe',
        component: AssignedToMeComponent,
        canActivate: [groupGuard, MsalGuard],
        data: { groups: ['DIA-CustomsUser-', 'DIA-CustomsAdminUser-'] }
    },
    {
        path: 'Allassigned',
        component: AllassignedComponent,
        canActivate: [groupGuard, MsalGuard],
        data: { groups: ['DIA-CustomsUser-', 'DIA-CustomsAdminUser-'] }
    },

    {
        path: 'Unassigned',
        component: UnassignedComponent,
        canActivate: [groupGuard, MsalGuard],
        data: { groups: ['DIA-CustomsUser-', 'DIA-CustomsAdminUser-'] }
    },
    {
        path: 'Reprocessing',
        component: ReprocessingComponent,
        canActivate: [groupGuard, MsalGuard],
        data: { groups: ['DIA-CustomsUser-', 'DIA-CustomsAdminUser-'], status: 'reprocessing' }
    },
    {
        path: 'Firma',
        component: ReprocessingComponent,
        canActivate: [groupGuard, MsalGuard],
        data: { groups: ['DIA-CustomsUser-', 'DIA-CustomsAdminUser-'], status: 'firma' }
    },
    // {
    //     path: 'SearchParcel',
    //     component: SearchParcelComponent,
    //     canActivate: [groupGuard, MsalGuard],
    //     data: { groups: ['DIA-CustomsUser-', 'DIA-CustomsAdminUser-', 'DIA-NormalUser-'] }
    // },

    // {
    //     path: 'Terminal',
    //     component: TerminalComponent,
    //     canActivate: [groupGuard, MsalGuard],
    //     data: { groups: ['DIA-CustomsUser-', 'DIA-CustomsAdminUser-', 'DIA-NormalUser-'] }
    // },
    {
        path: 'Search',
        component: SearchComponent,
        canActivate: [groupGuard, MsalGuard],
        data: { groups: ['DIA-CustomsUser-', 'DIA-CustomsAdminUser-', 'DIA-NormalUser-'] }
    },
    {
        path: 'RetrievalRequests',
        component: RetrievalRequestsComponent,
        canActivate: [MsalGuard, retrievalRequestsUserGuard],
    },
    {
        path: 'UserManagement',
        component: UsersManagementComponent,
        canActivate: [groupGuard, MsalGuard],
        data: { groups: ['DIA-SuperUser-'] }
    },
    {
        path: 'access-denied',
        component: AccessDeniedComponentComponent,
    },
    {
        path: '**',
        redirectTo: '/Auth',
        pathMatch: 'full'
    }
];
